module.exports = __webpack_public_path__ + "static/media/TransactionCanceled.d274d6a2.svg";